export const getPlayerUnits = (player, units) => {
  return units.filter(u => u.ownerId === player.id);
}